import useVant from './vant'

export default function InstallPlugins(App) {
  useVant(App)
}
